module.exports = __webpack_public_path__ + "static/media/house.b71a8f6e.png";